module.exports = __webpack_public_path__ + "img/bridgestone.d2a37a1d.svg";